import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";
import systemStore from "../../../../storage/SystemStore";

import Btn from "../../../../ui/Btn";
import PageLayout from "../../../PageLayout";

import CompanyUserCommon from "./CompanyUserCommon";


const CompanyUserForm = ({
    children,
    title,
}) => {

    const navigate =
        useNavigate();

    const member =
        clubStore.member;


    const [
        saving,
        setSaving,
    ] = useState(false);


    const save = async () => {
        if (saving) {
            return;
        }
        setSaving(true);
        try {
            await clubStore.saveMember();
            systemStore.setSuccess(
                appStore.tr.successfully_saved
            );
            navigate(
                "/manager/member/list"
            );
        } catch (error) {
            const errorCode =
                error?.message ||
                "save_error";
            systemStore.setError(
                appStore.tr[errorCode] ||
                errorCode
            );
        } finally {
            setSaving(false);
        }
    };


    return (
        <PageLayout
            header={
                <div className="col-12">
                    <h3 className="m-0">
                        {title}
                    </h3>
                </div>
            }
        >
            <div className="grid">
                <CompanyUserCommon
                    member={member}
                />
                {children}
                <div className="col-12 flex justify-content-center">
                    <Btn
                        type="button"
                        icon="pi pi-save"
                        severity="success"
                        className="w-full flex justify-content-center"
                        label={
                            member.id
                                ? appStore.tr.edit
                                : appStore.tr.add
                        }
                        loading={saving}
                        disabled={saving}
                        onClick={save}
                    />
                </div>
            </div>
        </PageLayout>
    );
};


export default observer(CompanyUserForm);